import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CalcularService {

  // Calcula cambio a pesos según opción (USD o UF), return simpre en CLP
  calcular(value, cambioPers) {console.log(cambioPers)
    let ret;
    let fraccion;
    let precioFra;
    let valorNeto;
    let cambio;

    if (typeof (value.cargo) === 'string') {
      value.cargo = Number(value.cargo);
    }
    if (typeof (value.descuento) === 'string') {
      value.descuento = Number(value.descuento);
    }

    if (typeof (value.TotalDescuentos) === 'string') {
      value.TotalDescuento = Number(value.TotalDescuentos);
    }

    if (value.moneda === 'CLP') {
      fraccion = (value.fraccion / 60) * value.precio;
      precioFra = fraccion + (value.precio);
      valorNeto = precioFra * value.unidades;
      // return ret = parseFloat((valorNeto - value.descuento) + value.cargo).toFixed(2);
      return ret = parseFloat((valorNeto - value.TotalDescuentos) + value.cargo);
      // return ret = parseFloat((valorNeto - value.TotalDescuentos) + value.cargo).toFixed(2);
    }
    else if (value.moneda === 'USD' || value.moneda === 'CLF' || value.moneda === 'EUR') {
      cambio = value.precio * Number(cambioPers.replace('.', '').replace(',', '.'));
      fraccion = (value.fraccion / 60) * cambio;
      precioFra = fraccion + (cambio);
      valorNeto = precioFra * value.unidades;
      //  return ret = parseFloat((valorNeto - value.descuento) + value.cargo).toFixed(2);
      return ret = parseFloat((valorNeto - value.TotalDescuentos) + value.cargo);
    }
    else if (value.Moneda[0] === 'CLP') {
      fraccion = (value.fraccion / 60) * value.PrecioNeto[0];
      precioFra = fraccion + (value.PrecioNeto[0]);
      valorNeto = precioFra * value.unidades;
      //  return ret = parseFloat((valorNeto - value.descuento) + value.cargo).toFixed(2);
      return ret = parseFloat((valorNeto - value.TotalDescuentos) + value.cargo);
    }
    else if (value.Moneda[0] === 'USD' || value.Moneda[0] === 'CLF' || value.Moneda[0] === 'EUR') {
      cambio = value.PrecioNeto[0] * Number(cambioPers.replace('.', '').replace(',', '.'));
      fraccion = (value.fraccion / 60) * cambio;
      precioFra = fraccion + (cambio);
      valorNeto = precioFra * value.unidades;
      //  return ret = parseFloat((valorNeto - value.descuento) + value.cargo).toFixed(2);
      return ret = parseFloat((valorNeto - value.TotalDescuentos) + value.cargo);
    }
    return ret;
  }

  // Calcula valores de items en la moneda propia del documento
  calcularValor(value, monedaDoc, monedaOc) {
    let ret;
    let fraccion;
    let precio;
    let valorNeto;

    // Prepara y valida los datos
    // Unidades
    if (value.unidades === null) {
      value.unidades = 0;
    }
    else if (typeof (value.unidades) === 'object') {
      value.unidades = Number(value.unidades[0]);
    }
    // Fracción
    if (value.fraccion === null) {
      value.fraccion = 0;
    }
    else if (typeof (value.fraccion) === 'object') {
      value.fraccion = Number(value.fraccion[0]);
    }
    // Descuento
    if (value.descuento === null) {
      value.descuento = 0;
    }
    else if (typeof (value.descuento) === 'string') {
      value.descuento = Number(value.descuento);
    }
    else if (typeof (value.descuento) === 'object') {
      value.descuento = Number(value.descuento[0]);
    }

    if (value.TotalDescuentos === null) {
      value.TotalDescuentos = 0;
    }
    else if (typeof (value.TotalDescuentos) === 'string') {
      value.TotalDescuentos = Number(value.TotalDescuentos);
    }
    else if (typeof (value.TotalDescuentos) === 'object') {
      value.TotalDescuentos = Number(value.TotalDescuentos[0]);
    }

    // Cargo
    if (value.cargo === null) {
      value.cargo = 0;
    }
    else if (typeof (value.cargo) === 'string') {
      value.cargo = Number(value.cargo);
    }
    else if (typeof (value.cargo) === 'object') {
      value.cargo = Number(value.cargo[0])
    }

    if (typeof (value.PrecioNeto) === 'object') {
      value.PrecioNeto = Number(value.PrecioNeto[0])
    }
    if (typeof (value.precioClp) === 'object') {
      value.precioClp = Number(value.precioClp[0])
    }
    if (typeof (value.precioNoClp) === 'object') {
      value.precioNoClp = Number(value.precioNoClp[0])
    }

    // Ejecuta las operaciones
    // Moneda CLP todo el documento
    if (monedaOc === 'CLP') {
      if (value.precio === undefined) {
        fraccion = (value.fraccion / 60) * value.PrecioNeto;
        precio = value.unidades * value.PrecioNeto;
        valorNeto = fraccion + precio;
        //  return ret = parseFloat((valorNeto - value.descuento) + value.cargo).toFixed();
        // return ret = parseFloat((valorNeto - value.TotalDescuentos) + value.cargo).toFixed();
        return ret = parseFloat((valorNeto - value.TotalDescuentos) + value.cargo);
      }
      else {
        fraccion = (value.fraccion / 60) * value.precio;
        precio = value.unidades * value.precio;
        valorNeto = fraccion + precio;
        // return ret = parseFloat((valorNeto - value.descuento) + value.cargo).toFixed();
        // return ret = parseFloat((valorNeto - value.TotalDescuentos) + value.cargo).toFixed();
        return ret = parseFloat((valorNeto - value.TotalDescuentos) + value.cargo);
      }
    }
    // Moneda !CLP (USD, EUR o CLF)
    else {
      if (monedaDoc === 'CLP' && value.precioClp !== undefined) {
        fraccion = (value.fraccion / 60) * value.precioClp;
        precio = value.unidades * value.precioClp;
        valorNeto = fraccion + precio;
        if (valorNeto === 0) {
          return ret = 0;
        }

        if (value.TotalDescuentosClp === 'NaN' || isNaN(value.TotalDescuentosClp)) {
          // return ret = parseFloat((valorNeto - value.descuento) + value.cargo).toFixed();
          return ret = parseFloat((valorNeto - value.descuento) + value.cargo);
        }
        else {
          // return ret = parseFloat((valorNeto - value.TotalDescuentosClp) + value.cargo).toFixed();
          return ret = parseFloat((valorNeto - value.TotalDescuentosClp) + value.cargo);
        }
      }
      else if (monedaDoc === 'CLP' && value.moneda === 'CLP') {
        fraccion = (value.fraccion / 60) * value.precio;
        precio = value.unidades * value.precio;
        valorNeto = fraccion + precio;
        //  return ret = parseFloat((valorNeto - value.descuento) + value.cargo).toFixed();
        return ret = parseFloat((valorNeto - value.descuento) + value.cargo);

        // return ret = parseFloat((valorNeto - value.TotalDescuentos) + value.cargo).toFixed();
      }
      else if (monedaDoc !== 'CLP' && value.precioNoClp !== undefined) {
        fraccion = (value.fraccion / 60) * value.precioNoClp;
        precio = value.unidades * value.precioNoClp;
        valorNeto = fraccion + precio;
        // return ret = parseFloat((valorNeto - value.descuento) + value.cargo).toFixed(2);
        return ret = parseFloat((valorNeto - value.descuento) + value.cargo);

        // return ret = parseFloat((valorNeto - value.TotalDescuentos) + value.cargo).toFixed(2);
      }
      else if (value.PrecioNeto === undefined) {
        fraccion = (value.fraccion / 60) * value.precio;
        precio = value.unidades * value.precio;
        valorNeto = fraccion + precio;
        // return ret = parseFloat((valorNeto - value.descuento) + value.cargo).toFixed(2);
        return ret = parseFloat((valorNeto - value.descuento) + value.cargo);

        // return ret = parseFloat((valorNeto - value.TotalDescuentos) + value.cargo).toFixed(2);
      }
      else {
        fraccion = (value.fraccion / 60) * value.PrecioNeto;
        precio = value.unidades * value.PrecioNeto;
        valorNeto = fraccion + precio;

        if (valorNeto === 0) {
          return ret = 0;
        }
        if (monedaDoc === 'CLP') {
          //  return ret = parseFloat((valorNeto - value.descuento) + value.cargo).toFixed();

          return ret = parseFloat((valorNeto - value.TotalDescuentos) + value.cargo);
          // return ret = parseFloat((valorNeto - value.TotalDescuentos) + value.cargo).toFixed();
        }
        else {
          //  return ret = parseFloat((valorNeto - value.descuento) + value.cargo).toFixed(2);

          return ret = parseFloat((valorNeto - value.TotalDescuentos) + value.cargo);
          // return ret = parseFloat((valorNeto - value.TotalDescuentos) + value.cargo).toFixed(2);
        }
      }
    }
  }

  calcularBal(saldoOc, totalNeto, monedaOc, cambioPers, monedaDoc?) {
    let ret: Number;
    let cambio: any;
    if (monedaOc === 'CLP') {
      return ret = Number(saldoOc) - Number(totalNeto);
    }
    else {
      if (monedaDoc === 'USD' || monedaDoc === 'CLF' || monedaDoc === 'EUR') {
        return ret = Number(saldoOc) - Number(totalNeto);
      }
      else {
        if (typeof (cambioPers) === 'number') {
          cambioPers = cambioPers.toString().replace('.', ',');
        }
        cambio = Number(totalNeto) / Number(cambioPers.replace('.', '').replace(',', '.'));     
        return ret = Number(saldoOc) - cambio;

      }
    }
  }

  calcularTotal(totalNeto, descuento, cargo, iva, totalEdit?) {
    let ret = {
      subtotal: null,
      total: null,
      balanceTotal: null
    };

    ret.subtotal = (totalNeto - descuento) + cargo;
    ret.total = ret.subtotal + iva;
    ret.balanceTotal = ret.total - totalEdit;
    return ret;
  }

  //total con descuentos = multas y notas de crédito/débito
  calcularTotalFinal(totalNotas: any, multa: any): number {
    let total = 0;
    const multaSanitizada = parseFloat(
      multa ? multa.toString().replace(/\./g, '').replace(',', '.') : '0'
    ) || 0;
  
    const totalNotasSanitizado = parseFloat(
      totalNotas ? totalNotas.toString().replace(/\./g, '').replace(',', '.') : '0'
    ) || 0;
  
    return total = totalNotasSanitizado - multaSanitizada;
  }
}
